document.addEventListener('DOMContentLoaded',function(e){
    let myAccountBtns = document.querySelectorAll('.my-account-btn');
    if(myAccountBtns){
        for(btn of myAccountBtns){
            btn.addEventListener('click', e => {
                e.currentTarget.querySelector('.account-wrapper').classList.toggle('active');
            })
        }
    }
    let myCartBtns = document.querySelectorAll('.my-cart-btn')
    if(myCartBtns){
        for(btn of myCartBtns){
            btn.addEventListener('click', e => {
                e.currentTarget.querySelector('.shopping-cart-content').classList.toggle('active');
            })
        }
    }
    let disabledMenuItems = document.querySelectorAll('header .with-submenu.menu-item');
    if(disabledMenuItems){
        for(dbtn of disabledMenuItems){
            dbtn.addEventListener('click',e => {
                e.preventDefault();
                e.currentTarget.querySelector('header .mega-menu-wrapper').classList.toggle('active');
                let activeSubmenus = document.querySelectorAll('header .mega-menu-wrapper.active');
                for (activeItem of activeSubmenus) {
                    if (activeSubmenus.length > 1) {
                        if (!activeItem.classList.contains(e.currentTarget.querySelector('header .mega-menu-wrapper').classList[1])) {
                            activeItem.classList.toggle('active')
                        }
                    }
                }
            });
        }
        let linksMegaMenu = document.querySelectorAll('header .mega-menu-wrapper li a');
        let textLink = document.querySelector('header .mega-menu-wrapper .img-wrapper.flex.items-center a');
        textLink.addEventListener('click', e => {
            window.location.href = e.currentTarget.href
        });
        for(link of linksMegaMenu){
            link.addEventListener('click', e => {
                window.location.href = e.currentTarget.href
            })
        }
        document.querySelector('#primary-content').addEventListener('click', e => {
            let activeSubmenus = document.querySelectorAll('header .mega-menu-wrapper.active');
            if (activeSubmenus.length > 0) {
                for (activeItem of activeSubmenus) {
                    activeItem.classList.toggle('active');
                }
            }
        })

        let throttleTimer;
        const throttle = (callback, time) => {
            if (throttleTimer) return;
            throttleTimer = true;
            setTimeout(() => {
                callback();
                throttleTimer = false;
            }, time);
        }
        window.addEventListener("scroll", () => {
            throttle(hideSubmenusOnScroll, 250);
        });
        const hideSubmenusOnScroll = () => {
            let activeSubmenus = document.querySelectorAll('header .mega-menu-wrapper.active');
            if (window.scrollY > 400 && activeSubmenus.length > 0) {
                for (activeItem of activeSubmenus) {
                    activeItem.classList.toggle('active');
                }
            }
        }
    }
})